import { useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

export interface DatasetFileConfig {
  id: string;
  prefix: string;
}

const useDatasetPrefixes = () => {
  const { datasetId } = useParams();
  return useFetcher<DatasetFileConfig[]>(`${VITE_CATALOG_API}/datasets/${datasetId}/file-configs`);
};

export default useDatasetPrefixes;
